import { formatDuration, getMessages } from "@/i18n/runtime";
import { compareHuge, deserializeHuge } from "@/shared/numbers";
import type { OfflineRewardResultModalModel } from "@/features/hoverIdle/offline/OfflineRewardResultModal";
import { formatForContext } from "@/features/hoverIdle/resources/numberFormat";

export function createOfflineRewardResultModel(result: {
  readonly rewardId: string;
  readonly timDelta: string;
  readonly receipt: {
    readonly gameElapsedMs: number;
    readonly wasCapped: boolean;
  };
}): OfflineRewardResultModalModel {
  return {
    rewardId: result.rewardId,
    appliedGameElapsedMs: result.receipt.gameElapsedMs,
    wasCapped: result.receipt.wasCapped,
    rewards: {
      tim: deserializeHuge(result.timDelta),
    },
  };
}

export function formatOfflineRewardToast(
  model: OfflineRewardResultModalModel,
): string {
  const timGain =
    compareHuge(model.rewards.tim, 0) > 0
      ? formatForContext(model.rewards.tim, "main")
      : null;
  return getMessages().offline.summary(
    formatDuration(model.appliedGameElapsedMs),
    timGain,
  );
}

export function formatUnavailableOfflineRewardSummary(): string {
  return getMessages().offline.rewardUnavailable();
}

export function formatRejectedOfflineRewardSummary(): string {
  return getMessages().offline.rewardCommitRejected();
}
